import React from "react";
import { Highlight, connectRefinementList } from "react-instantsearch-dom";

const PopularSubjectsFilter = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
}) => {
  return (
    <div className="flex lg:flex-row flex-col lg:px-6 lg:py-6">
      <div className="lg:w-1/5 w-full lg:uppercase lg:not-italic italic lg:font-display font-body lg:text-lg text-xs lg leading-loose text-darkgrey lg:mb-0 mb-2">Filter by popular subjects: </div>
      <div className="lg:w-4/5 w-full flex lg:flex-row flex-col flex-wrap">
        {items.map((item) => (
            <a
              href={createURL(item.value)}
              className={`group block text-center lg:px-3 lg:py-1 lg:mx-1 lg:mb-2 uppercase font-display text-lg lg:hover:text-white lg:hover:bg-red hover:text-red duration-300 ${item.isRefined ? "lg:text-white lg:bg-red text-red" : "text-darkgrey lg:bg-gray-100"}`}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
              key={item.label}
            >
              <div className="flex flex-row items-center">
                <div className={`lg:hidden bg-white h-4 w-4 mr-2 flex justify-center items-center border group-hover:border-red duration-300 ${item.isRefined ? "border-red" : "border-darkgrey"}`}>
                  <div className={`h-2.5 w-2.5 bg-red ${item.isRefined ? 'visible' : 'invisible'}`}></div>
                </div>
                {isFromSearch ? (
                  <Highlight attribute="label" hit={item} />
                ) : (
                  <span className="lg:mt-0 mt-0.5">{item.label.replace(/-/g, ' ').replace(/_/g, ' ')}</span>
                )}
              </div>
            </a>
        ))}
      </div>
      <div className="lg:hidden block h-px bg-darkgrey w-3/4 mr-auto mt-3"></div>
    </div>
  );
};

export default connectRefinementList(PopularSubjectsFilter);
